var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"referral-page",attrs:{"data-cy":"referral-page"}},[_c('Header'),_c('Benefits'),_c('About'),_c('Services'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }